import {LitElement, html, css} from 'lit';
import { customElement, property } from 'lit/decorators.js';
import { SldsBaseElement } from '../components/slds-base-element.js';

@customElement('notify-view')
class NotifyView extends SldsBaseElement {
  @property({ type: Boolean }) open = true;

  static styles = [
    super.styles,
    css`
      .slds-popover {
        background-color: var(--background-color, #fff);
        color: var(--text-color, #181818);
        border: 1px solid var(--border-color, #e5e5e5);
      }
    .slds-global-header__notification--unread, .slds-global-header__notification_unread {
      background-color: var(--table-hover, #f3f3f3);
    }
    .slds-nubbin--top-right:after, .slds-nubbin_top-right-corner:after, .slds-nubbin_top-right:after {
      box-shadow: -1px -1px 0 0 var(--border-color, #e5e5e5);
      z-index: -1;
    }
    .slds-global-header__notification {
      border-bottom: 1px solid var(--border-color, #e5e5e5);
    }
    .slds-global-header__notification:hover {
      background-color: var(--table-hover, #f3f3f3);
    }
    .slds-text-color--weak, .slds-text-color_weak {
        color: var(--text-color, #444);
      }
    `
  ];

  close() {
    this.open = false;
    this.dispatchEvent(new CustomEvent('close'));
  }

  render() {
    return html`
      ${this.open ? html`
      <section aria-describedby="dialog-body-id" aria-labelledby="dialog-heading-id" class="slds-popover slds-popover_large slds-nubbin_top-right" role="dialog">
        <button @click="${this.close}" class="slds-button slds-button_icon slds-button_icon-small slds-float_right slds-popover__close" title="Close dialog">
          <svg class="slds-button__icon" aria-hidden="true">
            <use xlink:href="/assets/icons/utility-sprite/svg/symbols.svg#close"></use>
          </svg>
          <span class="slds-assistive-text">Close dialog</span>
        </button>
        <div class="slds-popover__body slds-p-around_none" id="dialog-body-id">
          <div class="slds-media">
            <div class="slds-media__body">
              <header class="slds-popover__header">
                <h2 class="slds-text-heading_small slds-m-left_x-small slds-m-top_xx-small" id="dialog-heading-id">Alerts</h2>
              </header>
              <ul>
                <li class="slds-text-align_center slds-p-around_medium">
                  <div class="slds-text-heading_small slds-text-color_weak">
                    No notifications available
                  </div>
                </li>
                <!--
                <li class="slds-global-header__notification slds-global-header__notification_unread">
                  <div class="slds-media slds-has-flexi-truncate slds-p-around_x-small">
                    <div class="slds-media__figure">
                      <span class="slds-avatar slds-avatar_small">
                        <img alt="Jon Rogers" src="/assets/images/avatar3.jpg" title="Jon Rogers avatar" />
                      </span>
                    </div>
                    <div class="slds-media__body">
                      <div class="slds-grid slds-grid_align-spread">
                        <a href="#" class="slds-text-link_reset slds-has-flexi-truncate">
                          <h3 class="slds-truncate" title="Jon Rogers commented on your post">
                            <strong>Jon Rogers commented on your post</strong>
                          </h3>
                          <p class="slds-truncate" title="I totally agree with your sentiment">I totally agree with your sentiment</p>
                          <p class="slds-m-top_x-small slds-text-color_weak">13 hours ago
                            <abbr class="slds-text-link slds-m-horizontal_xxx-small" title="unread">●</abbr>
                          </p>
                        </a>
                      </div>
                    </div>
                  </div>
                </li>
                <li class="slds-global-header__notification">
                  <div class="slds-media slds-has-flexi-truncate slds-p-around_x-small">
                    <div class="slds-media__figure">
                      <span class="slds-avatar slds-avatar_small">
                        <img alt="Rebecca Stone" src="/assets/images/avatar2.jpg" title="Rebecca Stone avatar" />
                      </span>
                    </div>
                    <div class="slds-media__body">
                      <div class="slds-grid slds-grid_align-spread">
                        <a href="#" class="slds-text-link_reset slds-has-flexi-truncate">
                          <h3 class="slds-truncate" title="Rebecca Stone mentioned you">
                            <strong>Rebecca Stone mentioned you</strong>
                          </h3>
                          <p class="slds-truncate" title="@jrogers Here&#x27;s the conversation I mentioned to you">@jrogers Here&#x27;s the conversation I mentioned to you</p>
                          <p class="slds-m-top_x-small slds-text-color_weak">1 day ago</p>
                        </a>
                      </div>
                    </div>
                  </div>
                </li> -->
              </ul>
            </div>
          </div>
        </div>
      </section>
      ` : ''}
    `;
  }
}